// Import Components
import gxMenu from './../../components/menus/menu/Menu.vue'
import gxPopup from './../../components/menus/gxPopup.vue'
import gxStatusbar from './../../components/menus/gxStatusbar.vue'
import gxToolbar from './../../components/menus/gxToolbar.vue'

export default {
  gxMenu, gxPopup, gxStatusbar, gxToolbar
}
